import { Component, Element, Event, EventEmitter, h, Host, Prop, Watch } from "@stencil/core";
import pfx from "../../../utils/style-class-prefix-helper";
// import { InitLogging } from "../../../decorators/init-logging";

@Component({
  tag: "eon-ui-tab",
  styleUrl: "tab.scss",
  shadow: true
})
export class Tab {
  // @InitLogging() sentryTransaction;

  @Element() hostElement: HTMLEonUiTabElement;

  /**
   * Defines the header text of the tab
   */
  @Prop() header: string;

  /**
   * Determines whether the tab is active or not
   */
  @Prop() isActive: boolean;

  /**
   * Determines whether the tab has a notification
   */
  @Prop({ mutable: true }) notification: boolean = false;

  /**
   * Determines whether the tab has an icon
   */
  @Prop({ mutable: true }) icon: string;

  /**
   * Event for changing notification status
   */
  @Event() notificationChange: EventEmitter<any>;

  @Watch("notification")
  emitEvent() {
    this.notificationChange.emit();
  }

  render() {
    return (
      <Host>
        <div
          class={pfx({
            "tab-pane": true,
            active: this.isActive
          })}
        >
          <slot />
        </div>
      </Host>
    );
  }
}
